const ENVS_LIST = ['prd', 'uat', 'qa', 'dev'];
const ENV = process.env.REACT_APP_ENV;

/**
 * Create API URL with /api resource or get it from Consul if loaded.
 * @returns {string} URL with resource.
 */
function getApiUrl() {
    // load from consul:
    if (localStorage.getItem('hosts')) {
        const apiHost = JSON.parse(localStorage.getItem('hosts'))
        return apiHost.api.apiUrl;
    };

    // first load:
    let baseUrl = 'http://localhost:8080/api';

    if (ENVS_LIST.includes(ENV)) baseUrl = `https://${ENV}-btsapps.ciandt.com/api/perfectmatch/api`;
    if (ENV === 'prd') baseUrl = 'https://btsapps.ciandt.com/api/perfectmatch/api';
    if (ENV === 'newprd') baseUrl = 'https://novo-prd-btsapps.ciandt.com/api/perfectmatch/api';
    
    return baseUrl;
}

/**
 * Create API base URL or get it from Consul if loaded.
 * @returns {string} Base URL.
 */
export const getBaseUrl = () => {
    // load from consul:
    if (localStorage.getItem('hosts')) {
        const apiHost = JSON.parse(localStorage.getItem('hosts'))
        return apiHost.api.baseUrl;
    };

    // first load:
    let baseUrl = 'http://localhost:8080/';

    if (ENVS_LIST.includes(ENV)) baseUrl = `https://${ENV}-btsapps.ciandt.com/api/perfectmatch/`;
    if (ENV === 'prd') baseUrl = 'https://btsapps.ciandt.com/api/perfectmatch/';
    if (ENV === 'newprd') baseUrl = 'https://novo-prd-btsapps.ciandt.com/api/perfectmatch/api';
    
    return baseUrl;
};


export const getNotificationsApiUrl = () => {
    const hosts = JSON.parse(localStorage.getItem('hosts'));
    const notificationsHosts = hosts ? hosts.notifications : null;
    
    return notificationsHosts?.httpUrl;
}
export const getNotificationsSocketUrl = () => {
    const hosts = JSON.parse(localStorage.getItem('hosts'));
    const notificationsHosts = hosts ? hosts.notifications : null;
    
    return notificationsHosts?.socketUrl;
}

export default getApiUrl;
